// Author: Michael Kolesidis
// Title: uncanny canyon

// Copyright (c) 2023 Michael Kolesidis <michael.kolesidis@gmail.com>
// https://michaelkolesidis.com/

// Reproduction of any of the artwork on this website
// for commercial use is not permitted without first
// receiving written permission from the artist. You
// cannot host, display, distribute or share this Work
// in any form, including physical and digital. You
// cannot use this Work in any commercial or non-commercial
// product, website or project. You cannot sell this Work and
// you cannot mint an NFTs of it.

// Under the Copyright Law, it is fair use to reproduce a single
// copy for personal or educational purposes, provided that no
// changes are made to the content and provided that a copyright
// notice attesting to the content is attached to the reproduction.
// Beyond that, no further copies of works of art may be made or
// distributed on this website without written permission.

import * as THREE from "three";

// Head positions
export const headPositions = [
  { x: -37.3472, y: -0.4736, z: -51.2056 },
  { x: 60.2514, y: -0.4735, z: -238.7286 },
  { x: 41.5429, y: 14.1217, z: -171.182 },
  { x: -10.5056, y: -0.4735, z: -258.0651 },
  { x: -38.1468, y: 31.3499, z: -242.9543 },
  { x: -72.7389, y: 51.9802, z: -99.3168 },
  { x: -44.1077, y: -0.5448, z: -196.664 },
  { x: -117.5158, y: 36.89917, z: -346.7087 },
  { x: -80.6312, y: -0.4735, z: -394.5718 },
  { x: -87.8377, y: 2.9657, z: -505.6204 },
  { x: -123.9297, y: 74.12, z: -483.6523 },
];

export const head1position = new THREE.Vector3(-37.3472, -0.4736, -51.2056);
export const head2position = new THREE.Vector3(60.2514, -0.4735, -238.7286);
export const head3position = new THREE.Vector3(41.5429, 14.1217, -171.182);
export const head4position = new THREE.Vector3(-10.5056, -0.4735, -258.0651);
export const head5position = new THREE.Vector3(-38.1468, 31.3499, -242.9543);
export const head6position = new THREE.Vector3(-72.7389, 51.9802, -99.3168);
export const head7position = new THREE.Vector3(-44.1077, -0.5448, -196.664);
export const head8position = new THREE.Vector3(-117.5158, 36.89917, -346.7087);
export const head9position = new THREE.Vector3(-80.6312, -0.4735, -394.5718);
export const head10position = new THREE.Vector3(-87.8377, 2.9657, -505.6204);
export const head11position = new THREE.Vector3(-123.9297, 74.12, -483.6523);

// Other positions
export const caveEntrance = new THREE.Vector3(-5.8184, -0.4736, -8.6371);
